import double from './double'

/**
 * 转换时间戳为指定格式
 * @param { Number } timestamp
 * @param { String } formatter 输出格式 'YYYY-MM-DD' 'YYYY年MM月DD日' 替换其中的yyyy、mm、dd，可以自行设计替换模板
 * @return { String }
 */
export default (timestamp, formatter = 'YYYY年MM月DD日') => {
  const date = new Date()
  date.setTime(timestamp)

  return formatter
    .replace(/y{4}/i, date.getFullYear())
    .replace(/m{2}/i, double(date.getMonth() + 1))
    .replace(/d{2}/i, double(date.getDate()))
}
